<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 2/1/2023
  -->

<template>
	<div ref="root">
		<img ref="img" v-bind="$attrs"/>
		<LoadingIndicator/>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";

export default {
	name: "QwImg",
	components: {LoadingIndicator},
	extends: BaseComponent,

	props: {
		loadingIndicator: {Number, default: 0},
	},

	inheritAttrs: false,

	data() {
		return {
			classes: null,
		}
	},

	mounted() {
		// this.classes = this.$refs.root.getAttribute("class")
		// this.$refs.root.removeAttribute("class")
		this.setImgListeners()
	},

	methods: {
		setImgListeners() {
			let img = this.$refs.img
			if (!img.complete) {
				this.setLoadingState(true)
				img.addEventListener('load', () => this.setLoadingState(false))
				img.addEventListener('error', (error) => this.setLoadingState(false, error))
			}
		},

		setLoadingState(isLoading, error) {
			console.log("setLoadingState: ", ...arguments)
			this.$emit("loadingStateChanged", isLoading, error)
			this.imageLoadingStateChanged(isLoading, error)
		},

		imageLoadingStateChanged(isLoading, error) {
			if (isLoading) {
				this.showProgress()
			} else if (error) {
				console.log("imageLoadingStateChanged: ", error)
				this.hideProgressFail()
				if(error){
					this.toastWarn("Cannot load image")
				}
			} else {
				this.hideProgress()
			}
		},

	},
}
</script>

<style lang="scss">

</style>
